import { render, staticRenderFns } from "./Feeling.vue?vue&type=template&id=d22b02b8&scoped=true"
import script from "./Feeling.vue?vue&type=script&lang=js"
export * from "./Feeling.vue?vue&type=script&lang=js"
import style0 from "./Feeling.vue?vue&type=style&index=0&id=d22b02b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22b02b8",
  null
  
)

export default component.exports